import * as React from 'react';
import { useState } from 'react';
import { Title } from './Title/Title';
import { Page } from './Page/Page';
import { LargeControls } from './Controls/Large/Large';
import { SmallControls } from './Controls/Small/Small';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useLocation } from 'react-router-dom';
import './MisProcesos.css';

function MisProcesos(props) {

  const [numeroCaso, setNumeroCaso] = useState('');
  const [numeroValido, setNumeroValido] = useState(false);

  const [created, setCreated] = useState(false);
  const [addLoad, setAddLoad] = useState(true);
  const [alert, setAlert] = useState(false); 
  const [message, setMessage] = useState(''); 

  const [casos, setCasos] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [pages, setPages] = useState(0);

  const [queryCase, setQueryCase] = useState('');
  const [criteria, setCriteria] = useState('');
  const [order, setOrder] = useState(false);

  const location = useLocation();

  const title = location.pathname === '/mis-procesos' ? 'Mis Procesos' : location.pathname === '/importantes' ? 'Importantes' : location.pathname === '/archivados' ? 'Archivados' : null

  const loadCases = function() {
    let casos = [];
    // Load all cases pk from the user
    fetch(`${props.url}/procesos-api/get-all-cases`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token '+ localStorage.getItem('token'),
      },
      body: JSON.stringify({
        token: localStorage.getItem('token'),
        criterio: location.pathname === '/mis-procesos' ? false : true,
        importantes: location.pathname === '/importantes' ? true : false,
        page: page,
        perPage: perPage,
        queryCase: queryCase,
        criteria: criteria,
        order: order
      })
    })
    .then(res => res.json())
    .then(json => {
      json.casos.forEach((element) => casos.push(element))
    setCasos(casos)
    setPages(json.pages)
    setLoaded(true)
    })
  }

  React.useEffect(() => {
    let casos = [];
    // Load all cases pk from the user
    fetch(`${props.url}/procesos-api/get-all-cases`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token '+ localStorage.getItem('token'),
      },
      body: JSON.stringify({
        token: localStorage.getItem('token'),
        criterio: location.pathname === '/mis-procesos' ? false : true,
        importantes: location.pathname === '/importantes' ? true : false,
        page: page,
        perPage: perPage,
        queryCase: queryCase,
        criteria: criteria,
        order: order
      })
    })
    .then(res => res.json())
    .then(json => {
      json.casos.forEach((element) => casos.push(element))
    setCasos(casos)
    setPages(json.pages)
    setLoaded(true)
    })
  }, [props.url, location, page, perPage, queryCase, criteria, order])

  const newCase = async function(numeroCaso) {
    const responseCheckCase = await fetch(
      `${props.url}/procesos-api/check-exists`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Token '+ localStorage.getItem('token'),
        }, 
        body: JSON.stringify(
          {
            numeroCaso: numeroCaso
          }
        )
      }  
    )
    .then(res => res.json())
    .catch(() => {
      setMessage('Error creando caso');
      setAddLoad(true);
      setAlert(true);
      setCreated(false);
      setNumeroCaso('');
    })

    if (!responseCheckCase.exists) {
      const responseCreateCase = await fetch(
        `${props.url}/procesos-api/crear-proceso`,
        {
          method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Token '+ localStorage.getItem('token'),
        }, 
        body: JSON.stringify(
          {
            numeroCaso: numeroCaso
          }
        )
        }
      )
      .then(res => res.json())
      .catch(() => {
        setMessage('Error creando caso');
        setAddLoad(true);
        setAlert(true);
        setCreated(false);
        setNumeroCaso('');
      })

      if (responseCreateCase.code) {
        setMessage(responseCreateCase.message);
        setAddLoad(true);
        setAlert(true);
        setCreated(false);
        setNumeroCaso('');
      } else {
        setMessage(responseCreateCase.message);
        setAddLoad(true);
        setAlert(true);
        setCreated(true);
        setNumeroCaso('');
      }
    } else {
      setMessage('Caso creado con éxito');
      setAddLoad(true);
      setAlert(true);
      setCreated(true);
      setNumeroCaso('');
      loadCases();
    }
  }


  return (
    <React.Fragment>

      <Title title={title}/>

      <Snackbar
        open={alert}
        autoHideDuration={5000}
        onClose={() => setCreated(0)}>
        <Alert
          onClose={() => setAlert(false)}
          severity={created?"success":"error"}
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
      
      <LargeControls
        numeroCaso={numeroCaso}
        setNumeroCaso={setNumeroCaso} 
        numeroValido={numeroValido}
        setNumeroValido={setNumeroValido}
        newCase={newCase}
        addLoad={addLoad}
        setAddLoad={setAddLoad}
        casos={casos}
        setCasos={setCasos}
        setQueryCase={setQueryCase}
        setLoaded={setLoaded}
        setCriteria={setCriteria}
        setOrder={setOrder}
      /> 

      <div id={"feed"}> 
          <Page
            casos={casos}
            loaded={loaded}
            setOpenCaseInfo={props.setOpenCaseInfo} 
            loadCaseBreef={props.loadCaseBreef}
            url={props.url}
            location={location}
            page={page}
            setPage={setPage}
            perPage={perPage}
            setPerPage={setPerPage}
            pages={pages}
            setLoaded={setLoaded}
          />
      </div>

      <SmallControls 
        numeroCaso={numeroCaso}
        setNumeroCaso={setNumeroCaso} 
        numeroValido={numeroValido}
        setNumeroValido={setNumeroValido}
        newCase={newCase}
        addLoad={addLoad}
        setAddLoad={setAddLoad}
        casos={casos}
        setCasos={setCasos}
      />

    </React.Fragment >
  );
}

export { MisProcesos };
